import * as React from 'react';
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    margin: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 3,
        // transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: 'var(--varPirmaryIcon) !important', // primary from image
                opacity: 1,
                border: 0,
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#fff !important', // OFF state thumb color (will override with white in checked)
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 20,
        height: 20,
        margin: '-0.1px',
        backgroundColor: 'var(--varSecondaryIcon) !important', // OFF state thumb color (will override with white in checked)
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#FFFFFF', // OFF state track color
        opacity: 1,
        border: '1px solid var(--varSecondaryIcon) !important',
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    },
}));

export default function CustomizedToggle({ checked, onChange }) {
    return (
        <FormGroup>
            <IOSSwitch sx={{ m: 0 }} checked={checked} onChange={onChange} />
        </FormGroup>
    );
}
